import { Record } from 'immutable';

export const UserResume = new Record({
  isPending: false,
  error: null,
  data: []
  
});